import React from "react";
import AsyncSelect from "react-select/async";
import UserService from "../services/user.service";

const ClientAutocomplete = ({
  value,
  onChange,
  onBlur,
  isDisabled,
  placeholder,
  name,
}) => {
  const loadOptions = async (inputValue) => {
    if (!inputValue) {
      // Return empty or fetch default initial clients
      return [];
    }
    try {
      const response = await UserService.searchClients(inputValue);
      const data = response.data.data || response.data.results || response.data;
      return data;
    } catch (error) {
      console.error("Error fetching clients", error);
      return [];
    }
  };

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      getOptionLabel={(option) => option.clientName}
      getOptionValue={(option) => option.id}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
      placeholder={placeholder}
      name={name}
      isClearable
    />
  );
};

export default ClientAutocomplete;
